import axios from 'axios';
import { getCookie } from 'cookies-next';

// Crear una instancia de Axios con timeout extendido
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000'}/api`,
  timeout: 120000, // 2 minutos para operaciones largas (timbrado, PDFs)
});

// Configura el interceptor de solicitud
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getCookie('sesion_t');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
